import SettingsModule from './settings.module'

export default SettingsModule
